import React from 'react';
import './TwoPlyReflectivePage.css';

const models = [
  { name: 'DP-GR R 10', VLT: '5%', IRR: '95%', UVR: '100%', OD: '1.15', TSER: '78%' },
  { name: 'DP-BL R 15', VLT: '13%', IRR: '94%', UVR: '99%', OD: '0.96', TSER: '74%' },
  { name: 'DP-SL R 10', VLT: '1%', IRR: '93%', UVR: '99%', OD: '1.69', TSER: '85%' },
  { name: 'DP-GD R 10', VLT: '15%', IRR: '94%', UVR: '100%', OD: '97%', TSER: '78%' },
];

const TwoPlyReflectivePage = () => (
  <main className="two-ply-reflective-main">
    <section className="two-ply-reflective-top">
      <div className="two-ply-reflective-top-content">
        <h1>2 Ply Reflective Film</h1>
      </div>
    </section>

    <section className="two-ply-reflective-hero">
      <div className="two-ply-reflective-hero-content">
        <p className="two-ply-reflective-intro">
          Derma Protec's 2 Ply Reflective Film is a durable and performance-driven window film engineered for both residential and commercial buildings. It combines functionality with aesthetics to reduce heat, improve privacy, and enhance the overall look of your space.
        </p>
      </div>
    </section>

    <section className="two-ply-reflective-what">
      <h2>🛡 What is 2 Ply Reflective Film?</h2>
      <p>"2 Ply" refers to a film constructed using two distinct layers bonded together for improved strength and performance over single ply alternatives. This layered system enhances durability, optical clarity, and heat rejection, making it a versatile and long-lasting solar control solution.</p>
    </section>

    <section className="two-ply-reflective-layers">
      <h2>🧱 Layer Structure</h2>
      <ul className="two-ply-reflective-layers-list">
        <li><b>1. Outer Layer (Reflective)</b> — A mirror-like finish that reflects sunlight and provides daytime privacy. Helps give buildings a modern, polished appearance.</li>
        <li><b>2. Base Layer (Adhesive & UV Barrier)</b> — This foundational layer ensures secure bonding to glass and blocks up to 100% of harmful UV rays.</li>
      </ul>
      <p>Together, these layers deliver a product that is sleek, long-lasting, and highly functional.</p>
    </section>
    <div className="two-ply-reflective-img-center">
      <img src="https://i.postimg.cc/DZJrDGcV/2-ply-dermaa-2.png" alt="2 Ply Derma Example 2" className="two-ply-reflective-content-img" />
    </div>

    <section className="two-ply-reflective-benefits">
      <h2>🌟 Key Features & Benefits</h2>
      <ul className="two-ply-reflective-benefits-list">
        <li><b>Mirror-Type Reflective Finish</b> — Enhances aesthetics while offering daytime privacy with a silver-tinted, modern look from the outside.</li>
        <li><b>UV Protection</b> — Blocks up to 100% of harmful UV radiation, reducing fading of interiors such as curtains, carpets, and furniture.</li>
        <li><b>Heat & Glare Reduction</b> — Effectively reduces solar heat gain and eye strain caused by glare—improving indoor comfort.</li>
        <li><b>Improved Energy Efficiency</b> — Reduces the need for air conditioning during hot weather, helping lower energy bills.</li>
        <li><b>Durable Construction</b> — Designed to resist peeling, bubbling, and discoloration even with prolonged sun exposure. Lifespan of up to 5 years in harsh conditions.</li>
        <li><b>Quick Installation & Easy Maintenance</b> — Engineered for smooth application and effortless cleaning.</li>
      </ul>
    </section>
    <div className="two-ply-reflective-img-center">
      <img src="https://i.postimg.cc/DfGQPqZL/2-ply-derma.png" alt="2 Ply Derma Example" className="two-ply-reflective-content-img" />
    </div>

    <section className="two-ply-reflective-models">
      <h2>Dual-Reflective Films</h2>
      <div className="two-ply-reflective-table-wrapper">
        <table className="two-ply-reflective-table models">
          <thead>
            <tr>
              <th>Model</th>
              <th>VLT</th>
              <th>IRR</th>
              <th>UVR</th>
              <th>O.D</th>
              <th>TSER</th>
            </tr>
          </thead>
          <tbody>
            {models.map(model => (
              <tr key={model.name}>
                <td>{model.name}</td>
                <td>{model.VLT}</td>
                <td>{model.IRR}</td>
                <td>{model.UVR}</td>
                <td>{model.OD}</td>
                <td>{model.TSER}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  </main>
);

export default TwoPlyReflectivePage; 